import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

function ConfirmButton({
  onConfirm,
  disabled = false,
  buttonText = "Xóa",
  confirmText = "Bạn có chắc chắn?",
  confirmButtonLabel = "Xác nhận",
  cancelButtonLabel = "Hủy",
  variant = "contained",
  color = "secondary",
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleConfirm = () => {
    setOpen(false);
    onConfirm(); // gọi hàm xác nhận
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        fullWidth
        variant={variant}
        color={color}
        disabled={disabled}
        onClick={handleClickOpen}
      >
        {buttonText}
      </Button>

      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">Xác nhận</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            {confirmText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {cancelButtonLabel}
          </Button>
          <Button
            onClick={handleConfirm}
            color="secondary"
            variant="contained"
            autoFocus
          >
            {confirmButtonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConfirmButton;
